// VW FONTSIZE
function coSetResponsiveFontSize() {
    const root = document.documentElement;
    const vw = window.innerWidth / 10;
    root.style.setProperty('--co-vw-font-size', `${vw}px`);
}
coSetResponsiveFontSize();
window.addEventListener('resize', coSetResponsiveFontSize);
//X VW FONTSIZE
// IMAGE LOADER
const coImagesGlobalLoader = document.querySelectorAll('img.co-img-loader');
coImagesGlobalLoader.forEach((img) => {
    const coHandleImageLoad = () => {
        img.classList.add("co-img-loaded");
    };
    if (img.complete) {
        img.classList.add("co-img-completed");
    } else {
        img.addEventListener('load', coHandleImageLoad);
    }
});
//X IMAGE LOADER
(function() {
    'use strict';
    const leftUl = document.querySelector('.co-mega-menu-left-ul');
    const rightUl = document.querySelector('.co-mega-menu-right-ul');
    const leftItems = leftUl.querySelectorAll('li');
    const rightItems = rightUl.querySelectorAll('li');
    function removeAllActive() {
        leftItems.forEach(item => item.classList.remove('co-active'));
        rightItems.forEach(item => item.classList.remove('co-active'));
    }
    leftItems.forEach((item, index) => {
        item.addEventListener('mouseenter', function() {
            removeAllActive();
            this.classList.add('co-active');
            if (rightItems[index]) {
                rightItems[index].classList.add('co-active');
            }
        });
    });
})();
// MEGA MENU

(function() {
    'use strict';
    
    // Height management
    const sourceEl = document.querySelector('.co-mega-menu-frame-4');
    const targetEl = document.querySelector('.co-mega-menu-frame-3');

    if (sourceEl && targetEl) {
        const updateHeight = () => {
            targetEl.style.setProperty('--co-mega-menu-height', `${sourceEl.offsetHeight}px`);
        };
        updateHeight();
        const ro = new ResizeObserver(updateHeight);
        ro.observe(sourceEl);
    }

    // Detect if device supports touch
    const isTouchDevice = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);

    // Keyboard accessibility for mega menu
    const megaMenuTitle = document.querySelector('.co-mega-menu-title');
    const megaMenuTrigger = document.querySelector('.co-mega-menu-trigger');
    const megaMenuWrapper = document.querySelector('.co-mega-menu-wrapper');
    const shopUrl = megaMenuTrigger?.getAttribute('data-shop-url');
    const categoryLinks = document.querySelectorAll('.co-mega-menu-left-ul li');
    const leftUl = document.querySelector('.co-mega-menu-left-ul');
    const rightUl = document.querySelector('.co-mega-menu-right-ul');
    const mainButtons = document.querySelectorAll('.co-mega-menu-main-button a');
    const announcer = document.getElementById('mega-menu-announcer');

    if (!megaMenuTitle || !megaMenuTrigger) return;

    let isMenuOpen = false;
    let shopTapped = false; // Track if shop has been tapped
    let touchedCategories = new Set(); // Track which categories have been touched
    let touchStartTime = 0;

    // Announce to screen readers
    function announce(message) {
        if (announcer) {
            announcer.textContent = message;
        }
    }

    // Open menu
    function openMenu() {
        isMenuOpen = true;
        megaMenuTitle.classList.add('menu-open');
        megaMenuWrapper.removeAttribute('hidden');
        megaMenuTrigger.setAttribute('aria-expanded', 'true');
        announce('Shop menu opened. Use arrow keys to navigate categories, tab to navigate products.');
    }

    // Close menu
    function closeMenu() {
        isMenuOpen = false;
        shopTapped = false; // Reset shop tapped state
        megaMenuTitle.classList.remove('menu-open');
        megaMenuWrapper.setAttribute('hidden', '');
        megaMenuTrigger.setAttribute('aria-expanded', 'false');
        touchedCategories.clear(); // Reset touched categories
        
        // Reset to first category
        leftUl.querySelectorAll('li').forEach(li => {
            li.classList.remove('co-active');
            li.querySelector('a')?.removeAttribute('aria-current');
        });
        rightUl.querySelectorAll('li').forEach(li => {
            li.classList.remove('co-active');
            li.setAttribute('aria-hidden', 'true');
        });
        
        const firstCategory = categoryLinks[0];
        if (firstCategory) {
            firstCategory.classList.add('co-active');
            firstCategory.querySelector('a')?.setAttribute('aria-current', 'true');
            const firstBlockId = firstCategory.dataset.blockId;
            const firstProducts = rightUl.querySelector(`li[data-block-id="${firstBlockId}"]`);
            if (firstProducts) {
                firstProducts.classList.add('co-active');
                firstProducts.removeAttribute('aria-hidden');
            }
        }
    }

    // Switch active category
    function switchCategory(categoryLi) {
        const blockId = categoryLi.dataset.blockId;
        const categoryName = categoryLi.querySelector('a')?.textContent.trim();
        
        // Remove active class from all categories
        leftUl.querySelectorAll('li').forEach(li => {
            li.classList.remove('co-active');
            li.querySelector('a')?.removeAttribute('aria-current');
        });
        
        // Add active class to focused category
        categoryLi.classList.add('co-active');
        categoryLi.querySelector('a')?.setAttribute('aria-current', 'true');
        
        // Remove active class from all product lists
        rightUl.querySelectorAll('li').forEach(li => {
            li.classList.remove('co-active');
            li.setAttribute('aria-hidden', 'true');
        });
        
        // Add active class to corresponding products
        const correspondingProducts = rightUl.querySelector(`li[data-block-id="${blockId}"]`);
        if (correspondingProducts) {
            correspondingProducts.classList.add('co-active');
            correspondingProducts.removeAttribute('aria-hidden');
            
            // Announce the change
            const productCount = correspondingProducts.querySelectorAll('.co-mega-menu-article-title-frame a').length;
            announce(`${categoryName} selected. ${productCount} featured products available.`);
        }
    }

    // Get all focusable elements in order
    function getFocusableElements() {
        const elements = [];
        
        categoryLinks.forEach(categoryLi => {
            const link = categoryLi.querySelector('a');
            if (link) {
                elements.push({
                    element: link,
                    blockId: categoryLi.dataset.blockId,
                    type: 'category'
                });
            }
        });

        return elements;
    }

    // Get product links for a specific block
    function getProductLinksForBlock(blockId) {
        const productLi = rightUl.querySelector(`li[data-block-id="${blockId}"]`);
        if (!productLi) return [];
        
        return Array.from(productLi.querySelectorAll('.co-mega-menu-article-title-frame a'));
    }

    // Handle touch/click on shop trigger (iPad/touch devices)
    if (isTouchDevice) {
        // Use touchstart for better responsiveness on touch devices
        megaMenuTrigger.addEventListener('touchstart', function(e) {
            touchStartTime = Date.now();
        }, { passive: true });

        megaMenuTrigger.addEventListener('touchend', function(e) {
            const touchDuration = Date.now() - touchStartTime;
            
            // Only handle quick taps (not scrolls/swipes)
            if (touchDuration < 500) {
                e.preventDefault();
                
                if (!isMenuOpen) {
                    // First tap - open menu
                    openMenu();
                    shopTapped = true;
                } else if (shopTapped) {
                    // Second tap - navigate
                    if (shopUrl) {
                        window.location.href = shopUrl;
                    }
                } else {
                    // Menu was opened by other means
                    shopTapped = true;
                }
            }
        }, { passive: false });

        // Fallback to click event
        megaMenuTrigger.addEventListener('click', function(e) {
            e.preventDefault(); // Prevent any default behavior
        });

        // Close menu when tapping outside
        document.addEventListener('touchstart', function(e) {
            if (isMenuOpen && !megaMenuTitle.contains(e.target)) {
                closeMenu();
            }
        }, { passive: true });
    } else {
        // Desktop: Click navigates directly to shop URL
        megaMenuTrigger.addEventListener('click', function(e) {
            if (shopUrl) {
                window.location.href = shopUrl;
            }
        });
    }

    // Handle touch/click on category links (iPad/touch devices)
    if (isTouchDevice) {
        categoryLinks.forEach((categoryLi) => {
            const categoryLink = categoryLi.querySelector('a');
            if (!categoryLink) return;

            let categoryTouchStart = 0;

            categoryLink.addEventListener('touchstart', function(e) {
                categoryTouchStart = Date.now();
            }, { passive: true });

            categoryLink.addEventListener('touchend', function(e) {
                const touchDuration = Date.now() - categoryTouchStart;
                const blockId = categoryLi.dataset.blockId;
                
                // Only handle quick taps
                if (touchDuration < 500) {
                    if (!touchedCategories.has(blockId)) {
                        // First tap - show products, prevent navigation
                        e.preventDefault();
                        switchCategory(categoryLi);
                        touchedCategories.add(blockId);
                    }
                    // Second tap - allow navigation (don't prevent)
                }
            }, { passive: false });

            // Also prevent click for first tap
            categoryLink.addEventListener('click', function(e) {
                const blockId = categoryLi.dataset.blockId;
                if (!touchedCategories.has(blockId)) {
                    e.preventDefault();
                }
            });
        });
    }

    // Open menu on hover (mouse - desktop only)
    if (!isTouchDevice) {
        megaMenuTitle.addEventListener('mouseenter', () => {
            if (!isMenuOpen) {
                openMenu();
            }
        });

        megaMenuTitle.addEventListener('mouseleave', () => {
            if (isMenuOpen && !megaMenuTitle.contains(document.activeElement)) {
                closeMenu();
            }
        });
    }

    // Open menu on focus (keyboard)
    megaMenuTrigger.addEventListener('focus', () => {
        if (!isMenuOpen) {
            openMenu();
        }
    });

    // Keep menu open when navigating inside
    megaMenuTitle.addEventListener('focusin', () => {
        if (!isMenuOpen) {
            openMenu();
        }
    });

    // Close menu when focus leaves
    megaMenuTitle.addEventListener('focusout', (e) => {
        setTimeout(() => {
            if (!megaMenuTitle.contains(document.activeElement)) {
                closeMenu();
            }
        }, 0);
    });

    // Close menu on Escape key
    megaMenuTitle.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && isMenuOpen) {
            closeMenu();
            megaMenuTrigger.focus();
            announce('Shop menu closed.');
        }
    });

    // Handle Enter/Space on trigger for keyboard users
    megaMenuTrigger.addEventListener('keydown', (e) => {
        if ((e.key === 'Enter' || e.key === ' ') && shopUrl) {
            e.preventDefault();
            // Navigate to shop URL
            window.location.href = shopUrl;
        }
    });

    // Set up custom tab order
    function setupTabOrder() {
        const focusableElements = getFocusableElements();
        
        focusableElements.forEach((item, index) => {
            const categoryLink = item.element;
            
            // Handle Tab key on category links
            categoryLink.addEventListener('keydown', (e) => {
                if (e.key === 'Tab' && !e.shiftKey) {
                    // Tab forward - go to this category's products
                    const productLinks = getProductLinksForBlock(item.blockId);
                    
                    if (productLinks.length > 0) {
                        e.preventDefault();
                        productLinks[0].focus();
                    }
                } else if (e.key === 'Tab' && e.shiftKey) {
                    // Shift+Tab backward
                    if (index > 0) {
                        e.preventDefault();
                        focusableElements[index - 1].element.focus();
                    }
                }
            });
        });

        // Handle navigation within product links
        categoryLinks.forEach(categoryLi => {
            const blockId = categoryLi.dataset.blockId;
            const productLinks = getProductLinksForBlock(blockId);
            
            productLinks.forEach((productLink, productIndex) => {
                productLink.addEventListener('keydown', (e) => {
                    if (e.key === 'Tab' && !e.shiftKey) {
                        // Tab forward
                        if (productIndex < productLinks.length - 1) {
                            e.preventDefault();
                            productLinks[productIndex + 1].focus();
                        } else {
                            // Last product - check for main buttons
                            if (mainButtons.length > 0) {
                                e.preventDefault();
                                mainButtons[0].focus();
                            } else {
                                // Go to next category
                                const categoryIndex = Array.from(categoryLinks).findIndex(li => li.dataset.blockId === blockId);
                                if (categoryIndex < categoryLinks.length - 1) {
                                    e.preventDefault();
                                    categoryLinks[categoryIndex + 1].querySelector('a').focus();
                                }
                            }
                        }
                    } else if (e.key === 'Tab' && e.shiftKey) {
                        // Shift+Tab backward
                        if (productIndex > 0) {
                            e.preventDefault();
                            productLinks[productIndex - 1].focus();
                        } else {
                            // First product - go back to its category
                            e.preventDefault();
                            const categoryLi = leftUl.querySelector(`li[data-block-id="${blockId}"]`);
                            categoryLi?.querySelector('a')?.focus();
                        }
                    }
                });
            });
        });

        // Handle main buttons
        mainButtons.forEach((button, btnIndex) => {
            button.addEventListener('keydown', (e) => {
                if (e.key === 'Tab' && !e.shiftKey) {
                    if (btnIndex < mainButtons.length - 1) {
                        e.preventDefault();
                        mainButtons[btnIndex + 1].focus();
                    } else {
                        // Last button - go to next category or exit
                        const lastActiveCategory = leftUl.querySelector('li.co-active');
                        if (lastActiveCategory) {
                            const categoryIndex = Array.from(categoryLinks).indexOf(lastActiveCategory);
                            if (categoryIndex < categoryLinks.length - 1) {
                                e.preventDefault();
                                categoryLinks[categoryIndex + 1].querySelector('a').focus();
                            }
                        }
                    }
                } else if (e.key === 'Tab' && e.shiftKey) {
                    if (btnIndex > 0) {
                        e.preventDefault();
                        mainButtons[btnIndex - 1].focus();
                    } else {
                        // First button - go back to last product of active category
                        const activeCategory = leftUl.querySelector('li.co-active');
                        if (activeCategory) {
                            const blockId = activeCategory.dataset.blockId;
                            const productLinks = getProductLinksForBlock(blockId);
                            if (productLinks.length > 0) {
                                e.preventDefault();
                                productLinks[productLinks.length - 1].focus();
                            }
                        }
                    }
                }
            });
        });
    }

    // Handle category focus to show corresponding products (keyboard only)
    categoryLinks.forEach((categoryLi) => {
        const categoryLink = categoryLi.querySelector('a');
        if (!categoryLink) return;

        categoryLink.addEventListener('focus', () => {
            switchCategory(categoryLi);
        });

        // Handle hover for mouse users (desktop only)
        if (!isTouchDevice) {
            categoryLink.addEventListener('mouseenter', () => {
                switchCategory(categoryLi);
            });
        }
    });

    // Handle focus on product links to keep their category active (keyboard only)
    const allProductLinks = rightUl.querySelectorAll('.co-mega-menu-article-title-frame a');
    allProductLinks.forEach(productLink => {
        productLink.addEventListener('focus', () => {
            const productLi = productLink.closest('li[data-block-id]');
            if (productLi) {
                const blockId = productLi.dataset.blockId;
                const categoryLi = leftUl.querySelector(`li[data-block-id="${blockId}"]`);
                
                if (categoryLi && !categoryLi.classList.contains('co-active')) {
                    switchCategory(categoryLi);
                }
            }
        });
    });

    // Initialize custom tab order
    setupTabOrder();

})();